var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flags"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_187)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 15,
    rx: 3,
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4H21V11H0V4Z",
    fill: "#FFDA2C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 6.222V8.742C9 9.442 8.328 10.002 7.5 10.002H5.5C4.674 10 4 9.437 4 8.74V6.22C4 5.648 4.448 5.17 5.064 5.015C5.25 4.495 5.822 4.961 6.5 4.961C7.182 4.961 7.75 4.498 7.936 5.016C8.55 5.175 9 5.654 9 6.222Z",
    fill: "#D4AF2C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 7H10V10H9V7ZM3 7H4V10H3V7Z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 9H10V10H9V9ZM3 9H4V10H3V9Z",
    fill: "#1A47B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 6H10V7H9V6ZM3 6H4V7H3V6Z",
    fill: "#D4AF2C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 6H6V7.5H5V6ZM7 8H8V9.5H7V8Z",
    fill: "#AF010D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 8H6V9.5H5V8Z",
    fill: "#FFDA2C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 6H8V7.5H7V6Z",
    fill: "#AE6A3E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 6L5 5H8L7 6H6Z",
    fill: "#AF010D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4H7V5H6V4Z",
    fill: "#D4AF2C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 15,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpain);
export default __webpack_public_path__ + "static/media/spain.4bdefee33abd1def1315798a9fb74a42.svg";
export { ForwardRef as ReactComponent };